import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import { API_KEY_API } from '@he-novation/config/apis/api-key-api';
import { ApiKeyInfo } from '@he-novation/config/types/api-key.types';
import { ApiKeyCreationBody } from '@he-novation/config/types/payloads/api-key.payload';

export const asyncApiKeyList = async (workspaceName: string): Promise<ApiKeyInfo[]> =>
    buildApiCall(API_KEY_API.LIST)({ params: { workspaceName } }).then((response) =>
        response.map((apiKey) => ({
            uuid: apiKey.uuid,
            creationDate: new Date(apiKey.creationDate),
            expirationDate: new Date(apiKey.expirationDate),
            userUuid: apiKey.user.uuid,
            email: apiKey.user.email,
            picture: apiKey.user.picture,
            firstname: apiKey.user.firstname,
            lastname: apiKey.user.lastname
        }))
    );

export const asyncApiKeyCreate = async (workspaceName: string, payload: ApiKeyCreationBody) =>
    buildApiCall(API_KEY_API.POST)({ params: { workspaceName }, body: payload });

export const asyncApiKeyDelete = async (workspaceName: string, apiKeyUuid: string) =>
    buildApiCall(API_KEY_API.DELETE)({ params: { workspaceName, apiKeyUuid } });
